import React from 'react';
import { Fragment } from 'react';
import Header from '../../components/header'
import Footer from '../../components/footer';
import Carta from '../../components/carta';
import Head from '../../components/head';


function CartaScreen () {
    return (
        <Fragment>
            <Head titulo="Carta de Serviço aos Cidadãos - Portal da Transparência da Prefeitura de Macuco" />
            <Header />
            <Carta />
            <Footer />
        </Fragment>
    );
}

export default CartaScreen;